var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { INDENT, View, VIEW_BORDER } from "../View";
import { Text, TEXT_VIEW, TEXT_WEIGHT } from "../Text";
import { createUIElement } from "../helpers";
import { STACK_ALIGN, STACK_DIRECTION, STACK_GAP, StackView } from "../StackView";
export var DialogWizardContentHeader = createUIElement('DialogWizardContentHeader', function (_a, ref) {
    var className = _a.className, title = _a.title, description = _a.description, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "title", "description", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    if (!title && !description) {
        return null;
    }
    return (React.createElement(StackView, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'dialog-wizard-content-header', className: "vm-DialogWizardContentHeader " + className, spaceVertical: INDENT.s, spaceHorizontal: INDENT.m, direction: STACK_DIRECTION.column, align: STACK_ALIGN.fill, gap: STACK_GAP.xs, borderBottom: VIEW_BORDER.normal, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(Text, { weight: TEXT_WEIGHT.bold }, title || ''),
        description && (React.createElement(View, null,
            React.createElement(Text, { view: TEXT_VIEW.secondary }, description)))));
});
//# sourceMappingURL=DialogWizardContentHeader.js.map